<template>
    <v-btn
        v-show="isVisible"
        icon
        color="tertiary"
        size="large"
        elevation="4"
        class="scroll-to-top-fab"
        @click="handleClick"
    >
        <v-icon>{{
            isScrolledDown ? "mdi-chevron-up" : "mdi-chevron-down"
        }}</v-icon>
    </v-btn>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from "vue";

const isVisible = ref(false);
const isScrolledDown = ref(false);
const scrollThreshold = 300;

const checkPageHeight = () => {
    // Verificar si hay contenido que exceda la altura de la ventana
    const hasScrollableContent =
        document.documentElement.scrollHeight >
        document.documentElement.clientHeight;
    isVisible.value = hasScrollableContent;
};

const handleScroll = () => {
    // Verificar visibilidad del botón basado en altura de contenido
    checkPageHeight();

    // Determinar si el usuario ha bajado lo suficiente
    isScrolledDown.value = window.scrollY >= scrollThreshold;
};

const handleResize = () => {
    // Recalcular visibilidad cuando cambia el tamaño de la ventana
    checkPageHeight();
    handleScroll();
};

const handleLoad = () => {
    // Verificar cuando la página completa (incluyendo imágenes) se ha cargado
    checkPageHeight();
    handleScroll();
};

const initializeVisibility = async () => {
    // Esperar a que el DOM esté completamente renderizado
    await nextTick();

    // Dar un pequeño delay para que contenido asíncrono pueda renderizarse
    setTimeout(() => {
        checkPageHeight();
        handleScroll();
    }, 100);
};

const handleClick = () => {
    if (isScrolledDown.value) {
        // Usuario está abajo: scroll hacia arriba
        scrollToTop();
    } else {
        // Usuario está arriba: scroll hacia abajo
        scrollToBottom();
    }
};

const scrollToTop = () => {
    window.scrollTo({
        top: 0,
        behavior: "smooth",
    });
};

const scrollToBottom = () => {
    window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: "smooth",
    });
};

onMounted(() => {
    // Inicializar visibilidad
    initializeVisibility();

    // Verificar también cuando la página completa se carga
    if (document.readyState === "complete") {
        handleLoad();
    } else {
        window.addEventListener("load", handleLoad);
    }

    // Agregar listeners
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
    // Limpiar listeners
    window.removeEventListener("scroll", handleScroll);
    window.removeEventListener("resize", handleResize);
    window.removeEventListener("load", handleLoad);
});
</script>

<style scoped>
/* 24px a la izquierda del espacio del Wonderchat (100×100 px) */
.scroll-to-top-fab {
    position: fixed;
    bottom: 20px;
    right: 124px;
    z-index: 9999;
}
</style>
